import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';

@Component({
  selector: 'app-user-wise-detailed',
  templateUrl: './user-wise-detailed.component.html',
  styleUrls: ['./user-wise-detailed.component.css']
})

export class UserWiseDetailedComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private _exportService: ExportService) { }

  formTitle = "Short Day Wise Report";
  loadprojectexcel: boolean = false;

  ngOnInit(): void {
    this.loadAllProjects(this.str);
    this.loadAllAssignee();
    // this.loadAllRoles();
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
  }

  dt = new Date();
  month: number;
  year: number;
  START_DATE: string;
  END_DATE: string;
  radioValue = "E";

  getMonthAndYear() {
    this.month = this.dt.getMonth();
    this.year = this.dt.getFullYear();
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["PROJECT", "Project"], ["MODULE", "Module"], ["FEATURE", "Feature"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectDataForExcel = [];
  date = new Date();

  getUserWiseSummary(reset: boolean = false) {
    var ok = true;
    if (this.MODULE_ASSIGNEE_ID.length == 0) {
      ok = false
    }

    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }

      this.loadingRecords = true;
      var sort: string;
      try {
        sort = this.sortValue.startsWith("a") ? "asc" : "desc";

      } catch (error) {
        sort = "";
      }

      if (this.searchText != "") {
        var likeQuery = " AND";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });
        likeQuery = likeQuery.substring(0, likeQuery.length - 2)

      }

      this.filterClass = "filter-invisible";

      this.applyFilter();

      var filter = ""
      if (likeQuery)
        filter = this.filterQuery + likeQuery;
      else
        filter = this.filterQuery;

      this._apiService.getUserWiseProjectSummary(this.pageIndex, this.pageSize, this.sortKey, sort, this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
        this.loadingRecords = false;
        this.isProjectSpinning = false;
        this.totalRecords = data['count'];
        this.projectData = data['data'];

      }, err => {

        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });
    }
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";
  PROJECT_DATE = null;

  applyFilter() {
    this.getMonthAndYear();
    this.getDaysOfMonth(this.month, this.year);
    this.isFilterApplied = "primary";
    this.filterClass = "filter-invisible";
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";

    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.dt = new Date();
    this.date = this.dt;

    this.projectID = [];
    this.TYPE = "";
    this.str = "";

    this.loadAllProjects(this.str);
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
    this.loadAllAssignee();
    // this.loadAllRoles();
    this.getUserWiseSummary(true);
    this.radioValue = "E";
  }

  sortKey: string = "WORKED_DATETIME";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'WORKED_DATETIME';
    const sortOrder = (currentSort && currentSort.value) || 'desc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;

    if (this.MODULE_ASSIGNEE_ID.length != 0) {
      this.getUserWiseSummary();
    }
  }

  days = new Array();

  getDaysOfMonth(MM, yyyy) {

    this.days = [];

    this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');
    var d = new Date(this.START_DATE).getDate();


    this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
    var e = new Date(this.END_DATE).getDate();


    for (var i = d; i <= e; i++) {
      var date = new Date(yyyy, MM, i);
      if (date != null) {
        this.days.push(this.datePipe.transform(date, 'yyyy-MM-dd'));
      }
    }
  }

  findTotalDays(yyyy, MM) {
    var numOfDays = new Date(yyyy, MM + 1, 0).getDate();

    var d = new Date(yyyy, MM, 1);
    this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

    var e = new Date(yyyy, MM, numOfDays);
    this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    for (var i = 0; i < numOfDays; i++) {
      var date = new Date(yyyy, MM, i + 1);
      if (date != null) {
        this.days[i] = this.datePipe.transform(date, 'yyyy-MM-dd');
      }
    }
  }

  selectedProjectList = [];

  onEnterGetUserWiseSummary() {
    document.getElementById('button1').focus();
    this.getUserWiseSummary(true);
  }

  importInExcel() {
    var arry1 = [];
    var arry2 = [];
    var arry3 = [];

    var obj1: any = new Object();
    var obj2: any = new Object();
    var obj3: any = new Object();
    this.loadprojectexcel = true;
    // Get Data for Excel Sheet
    this._apiService.getUserWiseProjectSummary(0, 0, this.sortKey, 'asc', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      if (data['code'] == 200) {
        this.projectDataForExcel = data['data'];
        this.loadprojectexcel = false;
        if (data['data'].length > 0) {
          for (var i = 0; i < this.projectDataForExcel.length; i++) {
            obj1['Start Date'] = this.datePipe.transform(this.projectDataForExcel[i]['WORKED_DATETIME'], 'dd-MMM-yyyy');;
            obj1['User'] = this.projectDataForExcel[i]['USER_NAME'];
            obj1['Project'] = this.projectDataForExcel[i]['PROJECT'];
            obj1['Module'] = this.projectDataForExcel[i]['MODULE'];
            obj1['Feature'] = this.projectDataForExcel[i]['FEATURE'];
            obj1['Total Time'] = this._apiService.convertIntoHMS(Number(this.projectDataForExcel[i]['FEATURE_TOTAL_SECONDS']));
            arry1.push(Object.assign({}, obj1));

            obj2['Start Date'] = this.datePipe.transform(this.projectDataForExcel[i]['WORKED_DATETIME'], 'dd-MMM-yyyy');
            obj2['User'] = this.projectDataForExcel[i]['USER_NAME'];
            obj2['Project'] = this.projectDataForExcel[i]['PROJECT'];
            obj2['Module'] = this.projectDataForExcel[i]['MODULE'];
            obj2['Feature'] = this.projectDataForExcel[i]['FEATURE'];
            obj2['Total Seconds'] = this.projectDataForExcel[i]['FEATURE_TOTAL_SECONDS'];
            arry2.push(Object.assign({}, obj2));

            obj3['Start Date'] = this.datePipe.transform(this.projectDataForExcel[i]['WORKED_DATETIME'], 'dd-MMM-yyyy');
            obj3['User'] = this.projectDataForExcel[i]['USER_NAME'];
            obj3['Project'] = this.projectDataForExcel[i]['PROJECT'];
            obj3['Module'] = this.projectDataForExcel[i]['MODULE'];
            obj3['Feature'] = this.projectDataForExcel[i]['FEATURE'];
            obj3['Total'] = parseFloat(String(Number(this.projectDataForExcel[i]['FEATURE_TOTAL_SECONDS']) / 3600)).toFixed(2);
            arry3.push(Object.assign({}, obj3));

            if (i == this.projectDataForExcel.length - 1) {
              this._exportService.exportExcel(arry1, 'Short Day Wise Report (HH:MM:SS)');
              this._exportService.exportExcel(arry2, 'Short Day Wise Report (In Seconds)');
              this._exportService.exportExcel(arry3, 'Short Day Wise Report');
            }
          }
        } else {
          this.notificationService.info("Data not found", "");
        }
      } else {
        this.projectDataForExcel = [];
        this.loadprojectexcel = false;
      }
    }, err => {
      this.projectDataForExcel = [];
      this.loadprojectexcel = false;
    });

  }

  // Getting Users
  assigneeList = [];
  categoryID = 0;

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;

    this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' AND IS_ACTIVE=1').subscribe(userData => {
      if (userData['code'] == 200) {
        this.assigneeList = userData['data'];
        var userCategory = this.assigneeList.filter(x => x.ID == this._apiService.userId);
        if (userCategory != null && userCategory != undefined) {
          this.categoryID = userCategory[0]['TASK_CATEGORY_ID'];
        } else {
          this.categoryID = 0;
        }
        this.loadAllRoles();
      }

    }, err => {
    });
  }

  roleData = [];

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;

    // level = level + ',' + nextLevel;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(data => {
        if (data['code'] == 200) {
          this.roleData = data['data'];

          this.findNewAssigneeList();
          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getUserWiseSummary(true);
          }
        }

      }, err => {
      });

    } else {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', ' and LEVEL >= (' + level + ')').subscribe(data => {
        if (data['code'] == 200) {
          this.roleData = data['data'];
          this.findNewAssigneeList();
          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getUserWiseSummary(true);
          }
        }

      }, err => {
      });
    }
  }

  newAssigneeList = [];
  MODULE_ASSIGNEE_ID = [];
  TYPE = "";

  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.MODULE_ASSIGNEE_ID = [];

    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (Number(this.assigneeList[k]['ROLE_IDS']) == this.roleData[j]['ID']) {
          if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
            this.newAssigneeList.push(this.assigneeList[k]);

          } else if (this.cookie.get("level") == "4") {
            if (Number(this.assigneeList[k]['TASK_CATEGORY_ID']) == this.categoryID) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }

          } else {
            if (Number(this.assigneeList[k]['ID']) == this._apiService.userId) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }
          }
        }
      }
    }
    for (var i = 0; i < this.newAssigneeList.length; i++) {
      this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['ID']);
    }
  }

  projectID = [];
  projectList = [];

  loadAllProjects(str) {
    this.projectID = [];

    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', str).subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.projectList = projectData['data'];
        for (var i = 0; i < this.projectList.length; i++) {
          this.projectID.push(this.projectList[i]['ID']);
        }
      }

    }, err => {
    });
  }

  str = "";

  onStatusChange(type) {
    this.projectID = [];

    if (type == "B") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=1';

    } else if (type == "NB") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=0';

    } else if (type == null) {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE in (0,1)';
    }

    this.loadAllProjects(this.str);
  }

  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  startDateHandle(open: boolean) {
    this.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.END_DATE = this.START_DATE;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (this.START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var previousDate = new Date(this.START_DATE);
      previousDate.setDate(previousDate.getDate() + (-1));

      return endValue <= new Date(previousDate);
    };
  }

  changeRadioButton(radioButtonValue, apply = false) {
    if (radioButtonValue == "A") {
      let currentDate = new Date();
      this.START_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "B") {
      let currentDate = new Date();
      let previousDate = currentDate.setDate(currentDate.getDate() + (-1));

      this.START_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "C") {
      let currentDate = new Date();
      let previous6thDayDate = currentDate.setDate(currentDate.getDate() + (-6));
      let next7thDayDate = currentDate.setDate(currentDate.getDate() + (6));

      this.START_DATE = this.datePipe.transform(previous6thDayDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(next7thDayDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "D") {
      let currentDate = new Date();
      let lastMonth = currentDate.getMonth() + (-1);
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, lastMonth + 1, 0).getDate();

      let d = new Date(currentYear, lastMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, lastMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    } else if (radioButtonValue == "E") {
      let currentDate = new Date();
      let currentMonth = currentDate.getMonth();
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, currentMonth + 1, 0).getDate();

      let d = new Date(currentYear, currentMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, currentMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');
    }

    if (apply) {
      this.applyWithRadioButtons();
    }
  }

  applyWithRadioButtons() {
    this.loadingRecords = true;
    this.pageIndex = 1;
    this._apiService.getUserWiseProjectSummary(this.pageIndex, this.pageSize, 'WORKED_DATETIME', 'desc', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.projectData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }
}
